<app-header id="header"></app-header>
<app-progress-bar id="progress-bar" [planeColor]="'#0045b6'" [passengerColor]="'#0045b6'" [seatColor]="'#0045b6'"
    [ticketColor]="'#0045b6'"></app-progress-bar>
<app-flight-ticket></app-flight-ticket>
<app-footer id="footer"></app-footer>